<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text=""
      cancel-text=""
      :infos-arr="infos">
      <div slot="content">
        <lk-card title="门店使用详情">
          <lk-form
            ref="form"
            label-position="right"
            :label-width="114">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="">
                  <div>
                    <lk-table border :columns="columns" :data="tableData"></lk-table>
                  </div>
                  <div style="text-align:right">
                    <lk-page
                      :total="count"
                      :current="page"
                      size="small"
                      show-total
                      show-sizer
                      show-elevator
                      transfer
                      @on-change="handlePage"
                      @on-page-size-change="handlePageSize">
                    </lk-page>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import systemService from '../../services/system';

import utils from '../../libs/utils';

export default {
  name: 'proceedsTypeInfo',
  components: {
    baseFrame,
  },
  data() {
    return {
      payWayId: '',
      infos: [],
      page: 1,
      size: 10,
      count: 0,
      tableData: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        { title: '门店名称', key: 'sysStoreName', minWidth: 116 },
        {
          title: '启用时间-禁用时间',
          // key: 'timeListStr',
          minWidth: 116,
          render: (h, { row }) => {
            if (row.timeList && row.timeList.length === 0) {
              return h('span', '-');
            }
            const timeList = [];
            row.timeList.forEach((item) => {
              timeList.push(h('p'), item);
            });
            return h('div', [
              ...timeList,
            ]);
          },
        },
      ],
    };
  },
  computed: {
  },
  methods: {
    getData() {
      const params = {
        page: this.page,
        size: this.size,
        proceedsTypeId: this.payWayId,
      };
      systemService.getProceedsTypeListStore(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.timeListStr = result.timeList.join(' ') || '-';
            this.tableData.push(result);
          });
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getProceedsTypeInfo() {
      const params = {
        id: this.payWayId,
      };
      systemService.getProceedsTypeInfo(params).then((res) => {
        if (res.data.status === 200) {
          const proceedsType = res.data.data;
          this.infos = [
            {
              name: '付款方式名称：',
              value: proceedsType.name,
            },
            {
              name: '创建时间：',
              value: utils.formatTime(proceedsType.createTime),
            },
            {
              name: '创建人',
              value: proceedsType.createUserName,
            },
          ];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePageSize(val) {
      this.size = val;
      this.getData();
    },
    handlePage(val) {
      this.page = val;
      this.getData();
    },
  },
  created() {
    this.payWayId = this.$route.params.id;
    if (this.payWayId) {
      this.getData();
      this.getProceedsTypeInfo();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
